import { useState,useEffect } from 'react';
import {FormikProvider, useFormik} from 'formik';
import Cajas from '../../components/catalogo/Cajas';
import { axiosInstance } from "../../components/helpers/axiosInstance";
import TitleTooltip from "../../components/helpers/TitleTooltip";
import {validacionesCorteCaja} from "./validaciones/validacionesCorte";
import { FechaCorte } from "./componentes/PagoCaja";
import ErrorMessage from "../../components/helpers/ErrorMessage";
import dayjs from "dayjs";
import es from 'dayjs/locale/es'
import TablaCorte from "../../components/helpers/TablaCorte";
import CardCorte from "../../components/helpers/CardCorte";
import { useToast } from "../../components/notificaciones/ToastProvider";

/**
 * Arregl de denominaciones de billetes
 * @type {number[]}
 */
const Billetes = [1000,500, 200, 100, 50, 20, 10, 5, 2, 1];

/**
 * COMPONENTE PRINCIPAL
 * @returns {JSX.Element}
 * @constructor
 */
export default function BilletesEnCaja() {
    /**
     * Lista de inserciones que se han hecho
     */
    const [dinero, setDinero] = useState([]);
    /**
     * Fecha de día
     * @type {Date}
     */
    const date = new Date();
    /**
     * Manejo de notíficaciones
     * @type {undefined}
     * @property setArrayToast
     */
    const toast = useToast();
    /**
     * @function onSubmit envio de formulario
     * @param values
     */
      function onSubmit(values) {
        /**
         * Enviar arreglo vacio si todos los inputs estan en cero
         */
          const total = values.d1000 + values.d500 + values.d200 + values.d100 + values.d50 + values.d20 + values.d10 + values.d5 + values.d2 + values.d1;
          const data = total === 0 ? {} : {
              d1000: values.d1000,
              d500: values.d500,
              d200: values.d200,
              d100: values.d100,
              d50: values.d50,
              d20: values.d20,
              d10: values.d10,
              d5: values.d5,
              d2: values.d2,
              d1: values.d1,
          };
        /**
         * Petición al servidor
         * /cajas/100/cortes
         */
         axiosInstance.post('/cajas/' + values.id_caja + '/cortes', data).then(function (response) {
             /**
              * Sí se hace correctamente el envio de datos se suman a los datos guardados
              * en el estado dinero, se muestra el dialogo de confirmación y se reinician
              * los valores del formulario.
              */
              setDinero([...dinero, response.data]);
              toast.setArrayToast(
                  prevState => [
                      ...prevState,
                      {
                          id: response.data.id,
                          text: "Se registro el corte",
                          color: "success",
                          show: true
                      }
                  ]
              );
              formik.resetForm();
            }).catch(function (error) {
             /**
              * Cunado no se hizo el registro el usuario es informado y se muestranel error
              * de la API en el input correspondiente
              */
                 toast.setArrayToast(
                     prevState => [
                         ...prevState,
                         {
                             id: 'error',
                             text: error.response.data.errors[0].message,
                             color:'danger',
                             show: true
                         }
                     ]
                 )
                 formik.setFieldError(`${error.response.data.errors[0].input}`, `${error.response.data.errors[0].details}`);
            });
      }
    /**
     * @const valorInicial Valores iniciales de formulario
     * @type {{fecha: Date, id_caja: number, d1000: number, d500: number, d200: number, d100: number, d50: number, d20: number, d10: number, d5: number, d2: number, d1: number}}
     */
      const valorInicial = {
            fecha: date,
            id_caja: 100,
            d1000: 0,
            d500: 0,
            d200: 0,
            d100: 0,
            d50: 0,
            d20: 0,
            d10: 0,
            d5: 0,
            d2: 0,
            d1: 0,
      }

    /**
     * @const formik necesarias para el control del formulario
     */
      const formik = useFormik({
          initialValues: valorInicial,
          validationSchema : validacionesCorteCaja,
          validateOnMount : true,
          onSubmit,
      });

      console.log(formik.values.id_caja);

    return (
    <>
        <style type={'text/css'}>
            {`
                  .rs-picker-has-value .rs-btn .rs-picker-toggle-value, .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value{
                        color : var(--bs-gray-700)!important;
                  }  
                  
                  input[type='number'] {
                        -moz-appearance:textfield;
                  }
                  input::-webkit-outer-spin-button,input::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                  }
            `}
        </style>
        <CardCorte>
            <div className="card card-bordered d-flex flex-row-fluid flex-center">
                <FormikProvider value={formik}>
                    {
                        /**
                         * INICIA : Formulario para registro de corte
                         */
                    }
                    <form className="card-body py-15 w-100 px-10" onSubmit={formik.handleSubmit}>
                        <div className='row'>
                            <div className='col-md-3 col-xxl-2 mb-7'>
                                <FechaCorte formik={formik}></FechaCorte>
                            </div>
                            <div className={'col-md-3 col-xxl-2'}>
                                <Cajas formik={formik}></Cajas>
                                <ErrorMessage name={'id_caja'}></ErrorMessage>
                            </div>
                        </div>
                        <div className='row'>
                            <div className={'col-md'}>
                                <div className="form-floating">
                                    <input
                                        type={'number'}
                                        className="form-control form-control-solid"
                                        id="d1000"
                                        name="d1000"
                                        value={formik.values.d1000}
                                        placeholder="Cantidad"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="d1000" className={"text-gray-700"}>$ 1000</label>
                                </div>
                                <ErrorMessage name={"d1000"}></ErrorMessage>
                            </div>
                            <div className={'col-md'}>
                                <div className="form-floating">
                                    <input
                                        type='number'
                                        className="form-control form-control-solid"
                                        id="d500"
                                        name="d500"
                                        value={formik.values.d500}
                                        placeholder="Cantidad"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="d500" className={"text-gray-700"}>$ 500</label>
                                </div>
                                <ErrorMessage name={"d500"}></ErrorMessage>
                            </div>
                            <div className={'col-md'}>
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control form-control-solid"
                                        id="d200"
                                        name="d200"
                                        value={formik.values.d200}
                                        placeholder="Cantidad"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="d200" className={"text-gray-700"}>$ 200</label>
                                </div>
                                <ErrorMessage name={"d200"}></ErrorMessage>
                            </div>
                            <div className={'col-md'}>
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control form-control-solid"
                                        id="d100"
                                        name="d100"
                                        value={formik.values.d100}
                                        placeholder="Cantidad"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="d100" className={"text-gray-700"}>$ 100</label>
                                </div>
                                <ErrorMessage name={"d100"}></ErrorMessage>
                            </div>
                            <div className={'col-md'}>
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control form-control-solid"
                                        id="d50"
                                        name="d50"
                                        value={formik.values.d50}
                                        placeholder="Cantidad"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="d50" className={"text-gray-700"}>$ 50</label>
                                </div>
                                <ErrorMessage name={"d50"}></ErrorMessage>
                            </div>
                            <div className={'col-md'}>
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control form-control-solid"
                                        id="d20"
                                        name="d20"
                                        value={formik.values.d20}
                                        placeholder="Cantidad"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="d20" className={"text-gray-700"}>$ 20</label>
                                </div>
                                <ErrorMessage name={"d20"}></ErrorMessage>
                            </div>
                            <div className={'col-md'}>
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control form-control-solid"
                                        id="d10"
                                        name="d10"
                                        value={formik.values.d10}
                                        placeholder="Cantidad"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="d10" className={"text-gray-700"}>$ 10</label>
                                </div>
                                <ErrorMessage name={"d10"}></ErrorMessage>
                            </div>
                            <div className={'col-md'}>
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control form-control-solid"
                                        id="d5"
                                        name="d5"
                                        value={formik.values.d5}
                                        placeholder="Cantidad"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="d5" className={"text-gray-700"}>$ 5</label>
                                </div>
                                <ErrorMessage name={"d5"}></ErrorMessage>
                            </div>
                            <div className={'col-md'}>
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control form-control-solid"
                                        id="d2"
                                        name="d2"
                                        value={formik.values.d2}
                                        placeholder="Cantidad"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="d2" className={"text-gray-700"}>$ 2</label>
                                </div>
                                <ErrorMessage name={'d2'}></ErrorMessage>
                            </div>
                            <div className={'col-md'}>
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control form-control-solid"
                                        id="d1"
                                        name="d1"
                                        value={formik.values.d1}
                                        placeholder="Cantidad"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <label htmlFor="d1" className={"text-gray-700"}>$ 1</label>
                                </div>
                                <ErrorMessage name={'d1'}></ErrorMessage>
                            </div>
                        </div>
                        <div className={'d-flex justify-content-end mt-2'}>
                            <button className={'btn btn-primary'} type={'submit'} disabled={Object.keys(formik.errors).length > 0}>Enviar</button>
                        </div>
                    </form>
                    {
                        /**
                         * FIN : Formulario para registro de corte
                         */
                    }
                </FormikProvider>
            </div>
            <div className="card card-bordered d-flex flex-row-fluid flex-center mt-5">
                {
                    /**
                     * INICIA : Consultar corte
                     */
                }
                    <TablaDinero dinero={dinero} setDinero={setDinero} caja={formik.values.id_caja} />
                {
                    /**
                     * FIN : Consultar corte
                     */
                }
            </div>
        </CardCorte>
    </>
  );
}

/////////////////////////// COMPONENTE PRINCIPAL ///////////////////////////////////

/**
 * COMPONENTE: TABLA DE DINERO EN CAJA
 * @param dinero
 * @param setDinero
 * @param caja
 * @returns {JSX.Element}
 * @constructor
 */
function TablaDinero({ dinero, setDinero, caja }) {
    /**
     * Cambiar a español la libreria dayjs
     */
    dayjs.locale(es);
    /**
     * Hook de notíficaciones
     * @type {undefined}
     */
    const toast = useToast();
    /**
     * Petición al servidor
     */
      useEffect(() => {
        axiosInstance.get("/cajas/" + caja + "/cortes")
          .then((res) => {
              /**
               * Guardar los datos recibidos
               */
            setDinero(res.data);
          }).catch((error) => console.error(error));
      }, [caja,setDinero]);

    /**
     * @function handleDeleteRow eliminar fila
     * @param rowItem
     */
      function handleDeleteRow(rowItem) {
        axiosInstance.delete("/cajas/" + caja + "/cortes/" + rowItem)
          .then((res) => {
              if (res.status === 204) {
                  /**
                   * Quitar datos de tablas
                   */
                  setDinero( dinero.filter(t => t.id !== rowItem) );
                  /**
                   * Notificación : Se borró correctamente
                   */
                  toast.setArrayToast(
                      prevState => [
                          ...prevState,
                          {
                              id: rowItem,
                              text: 'Corte eliminado',
                              color: 'success',
                              show: true,
                          }
                      ]
                  )
              }
          }).catch((error) => {
              if (error.status === 404){
                  /**
                   * Notificación : API rechazo la petición por permisos del usuario
                   */
                  toast.setArrayToast(prevState => [
                      ...prevState,{
                        id : rowItem,
                        text : "Usuario sin acceso, el administrador del sistema sera notificado.",
                        color : "danger",
                        show: true,
                      }
                  ])
              } else {
                  /**
                   * Notificación : Fallo API
                   */
                  toast.setArrayToast(prevState => [
                      ...prevState,{
                            id : rowItem,
                            text : error.message,
                            color: 'danger',
                            show: true,
                      }
                  ])
              }
            }
        );
      }

    /**
     * @function nombreCaja Cambiar Caja de número a cadena
     * @param id
     * @returns {string}
     */
      function nombreCaja(id) {
        switch (id) {
          case 1:
            return "Fiducia Banamex";
          case 2:
            return "Fiducia Santander";
          case 100:
            return "Matriz";
          case 101:
            return "Oficina GDL";
          case 102:
            return "Módulo GDL";
          default:
            return "Oficina CMX";
        }
      }

  /**
   * @param c.capturo usuario que hizo la captura
   * @param c.valido
   * */
    return (
    <div className={'card-body py-15 w-100 px-10'}>
        <TablaCorte data={dinero}>
            <thead>
                <tr className={"fw-bold text-start text-muted pb-5 text-uppercase"}>
                    <th >Fecha</th>
                    <th >Capturo</th>
                    <th >Valido</th>
                    <th >Cuenta</th>
                    {
                        Billetes && Billetes.map((b) => <th key={b}>$ {b}</th>)
                    }
                    <th >Total</th>
                </tr>
            </thead>
            <tbody>
            {
                /**
                 * INICIA : FILA DE REGISTRO DE CORTE
                 */
            }
            {
                dinero && dinero.toReversed().map((c) => {
                    return (
                        <tr key={c.id} className='text-uppercase text-gray-900 fw-semibold text-start'>
                            <td className={'align-content-center'}>{dayjs(c.fecha).format('MMM DD, YYYY')}</td>
                            <td className={'align-content-center'}>{c.capturo}</td>
                            <td className={'align-content-center'}>{c.valido}</td>
                            <td className={'align-content-center'}>{nombreCaja(c.id_caja)}</td>
                            <td className={'align-content-center'}>{c.d1000}</td>
                            <td className={'align-content-center'}>{c.d500}</td>
                            <td className={'align-content-center'}>{c.d200}</td>
                            <td className={'align-content-center'}>{c.d100}</td>
                            <td className={'align-content-center'}>{c.d50}</td>
                            <td className={'align-content-center'}>{c.d20}</td>
                            <td className={'align-content-center'}>{c.d10}</td>
                            <td className={'align-content-center'}>{c.d5}</td>
                            <td className={'align-content-center'}>{c.d2}</td>
                            <td className={'align-content-center'}>{c.d1}</td>
                            <td className={'align-content-center'}>
                                <span className={"fw-bold fs-6"}>{c.total}</span>
                            </td>
                            {
                                dayjs(c.fecha).format('MMM DD, YYYY') === dayjs().format('MMM DD, YYYY') && <td className={'d-flex justify-content-end'}>
                                    <TitleTooltip title="Borrar Usuario" placement={'top'}>
                                        <button type={'button'} onClick={() => handleDeleteRow(c.id)} className="btn btn-sm btn-light-danger btn-icon">
                                            <i className="ki-solid ki-trash fs-5"></i>
                                        </button>
                                    </TitleTooltip>
                                </td>
                            }
                        </tr>
                    );
                })
            }
            {
                /**
                 * FIN : FILA DE REGISTRO DE CORTE
                 */
            }
            </tbody>
        </TablaCorte>
    </div>
  );
}

/////////////////////////// COMPONENTE: TABLA DE DINERO EN CAJA ///////////////////////////////////
